import { HttpClientModule } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { Auth } from '../../services/raintree/interfaces/auth';
import { AuthTransmissionService } from '../../services/raintree/Transmission/auth-transmission.service';
import { RaintreeResponse } from '../../services/raintree/interfaces/raintree-response';
import { AuthService } from '../../services/auth/auth-service';
import { CommonUtilService } from '../../services/common-util/common-util.service';
import { SnackbarService } from '../../services/common/snackbar.service';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FamilyCodeTransmissionService } from '../../services/raintree/Transmission/familyCode-transmission.service';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { FamilyCodeResponse } from '../../services/raintree/interfaces/family-code.interface';
import { DataTransferService } from '../../services/raintree/Transmission/data-transfer.service';
import { AppConfigService } from '../../services/config/app-config.service';
import { LocationService } from '../../services/common/location.service';
import { ReachAlertPopupComponent } from '../../reach-defaulter/reach-defaulter-popup/reach-alert-popup/reach-alert-popup.component';
import { ThemeToggleService } from '../../services/theme-Toggle/theme-toggle.service';
import { NotificationService } from '../../services/raintree/Transmission/notification.service';
import { FcmTokenService } from '../../services/common/fcm-token-service';
import { MasterSearchTransmissionService } from '../../services/raintree/Transmission/master-search.service';
import { ROUTES } from '../../services/server-route';
import { routes } from '../../app.routes';
import { RequestMapper } from '../../request-mapper';
import { StatusResolverService } from '../../services/raintree/Transmission/status-resolver.service';
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    HttpClientModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    MatAutocompleteModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  constructor(
    public familyCodeTransmissionService: FamilyCodeTransmissionService,
    private _authService: AuthService,
    private toaster: ToastrService,
    public dialog: MatDialog,
    private router: Router,
    private _authTransmissionService: AuthTransmissionService,
    private _commonUtilService: CommonUtilService,
    private _router: Router,
    private snackbar: SnackbarService,
    private masterSearchService: MasterSearchTransmissionService,
    private dataService: DataTransferService,
    private _apppConfig: AppConfigService,
    private location: LocationService,
    private themeToggleService: ThemeToggleService,
    private notificationService: NotificationService,
    private _fcmTokenService: FcmTokenService,
    private _activatedRoute: ActivatedRoute,
  private getstatusservice: StatusResolverService,
    ) { }
  public statusArray: any = [];
  emailInvalid = false;
  passwordInvalid = false;
  passwordVisible = false;
  selectedFC: boolean = false;
  isDisabled: boolean = false;
  fcDetails: any = [];
  allowedKeys: any[] = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'];
  public isloadingSpin: boolean = false;
  public errorMessage: string = '';
  visibilityOnIcon = '--pass-visibility-on';
  visibilityOffIcon = '--pass-visibility-off';
  isLoading: boolean = false;
  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    fc: new FormControl(''),
    password: new FormControl('', [
      Validators.required,
      // Validators.pattern(
      //   '^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).*$'
      // )
      Validators.pattern(
        '^(?!.*(?:\'|"|;|\\\\|\\/|`))(?!.*--)(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&*()_+\\-=\\[\\]{}:.,?~|<>])[A-Za-z\\d@#$%^&*()_+\\-=\\[\\]{}:.,?~|<>]{8,15}$'
      )
    ]),
  });
  fcpayload: any;
  ngOnInit(): void {
    localStorage.clear()
    this.themeToggleService.applyTheme('dark-gold');
    this.loginForm.get('fc')?.valueChanges.subscribe((value: any) => {
      const containsOnlyNumbers = /^\d+$/.test(value);
      if (value.length == 12 && containsOnlyNumbers) {
        this.isLoading = true;
        this.familyCodeTransmissionService
          .getFamilySignInDetails(value)
          .subscribe({
            next: (response: FamilyCodeResponse) => {
              if (!response.error) {
                this.fcDetails = response.data;
                this.isLoading = false;
              }
            },
            error: (error) => {
              this.isLoading = false;
              this.toaster.error(
                'Incorrect Family Code. Please check the code again.'
              );
            },
          });
      } else this.fcDetails = [];
    });
  }
  selectedDetail: any;
  memKey: any;
  firstName: any;
  lastName: any;
  crossIconVissible: boolean = false;
  locationGranted: boolean = false;
  getMemKey(memDetails: any) {
    this.crossIconVissible = true;
    this.loginForm.get('fc')?.disable();
    this.memKey = memDetails.memKey
    this.firstName = memDetails.name;
    this.lastName = memDetails.lastName;
  }
  clearFc() {
    this.loginForm.get('fc')?.setValue('');
    this.crossIconVissible = false;
    this.fcVerifiedIcon = false;
    this.loginForm.get('fc')?.enable();
  }
  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }
  onInputBlur(field: string) {
    if (field === 'email') {
      this.emailInvalid = this.loginForm.controls.email.invalid;
    }
    if (field === 'password') {
      this.passwordInvalid = this.loginForm.controls.password.invalid;
    }
  }
  payload: any = [];
  restrictFCInput(event: KeyboardEvent): void {
    const input = event.key;
    const limit = event.target as HTMLInputElement;
    const pattern = /[0-9]/;
    if (
      this.allowedKeys.includes(input) ||
      event.ctrlKey ||
      event.altKey ||
      event.metaKey
    ) {
      return;
    }
    if (!pattern.test(input) || limit.value.length > 11) {
      event.preventDefault(); // Prevent input if it doesn't match the pattern
    }
  }
  requireFc: boolean = false;
  requireEmailVerification: boolean = false;
  forcePwdReset: boolean = false;
  sessionId: any;
  public authenticate(): void {
    if (this.loginForm.invalid) return;
    let loginFormPayload: Auth = this.loginForm.value as Auth;
    this.isloadingSpin = true;
    this._authTransmissionService.getAuthToken(loginFormPayload).subscribe({
      next: async (response: RaintreeResponse) => {
        try {
          this.requireFc = response['data'].requiredFamilyCode;
          this.isloadingSpin = false;
          if (this.requireFc)
            this.toaster.success(
              'You need to verify your Familycode to move ahead with the LogIn process'
            );
          this.requireEmailVerification = response['data'].requiredVerifiedEmail;
          this.sessionId = response['data'].sessionId;
          this.forcePwdReset = response['data'].forcePwdReset ?? false;
          if (this.forcePwdReset) {
            this._router.navigate([RequestMapper.RESET_PASSWORD]);
            localStorage.setItem('resetSessionId', this.sessionId)
            localStorage.setItem('loginEmail', this.loginForm.get('email')?.value!)
            localStorage.setItem('loginPwd', btoa(this.loginForm.get('password')?.value!))
            localStorage.setItem('firstName', response['data'].firstName)
            localStorage.setItem('lastName', response['data'].lastName)
            localStorage.setItem('forceResetMob', response['data'].mobileNumber)
          } else {
            if (
              this._commonUtilService.isValidObject(response) &&
              response.hasOwnProperty('data') &&
              this._commonUtilService.getValidData(response['data'].accessToken)
            ) {
              // SAVE Token and helping local strorage data
              this._authService.storeJwtTokenInLocalStorage(response['data']);
              this.sendGeoLocation();
              this.fetchLastRefreshedDate()
              this.callApiService()
              // this._authService.resetRefreshTokenState()
              // if (this.notificationGranted)
              //   this.saveFcmToken();
              this._router.navigate([this._apppConfig.getLadingRoute()]);
            } else if (this.requireEmailVerification) {
              response['data'].linkedAccounts.forEach((elm: any) => {
                localStorage.setItem('familyCode', response['data'].familyCode);
                localStorage.setItem('sessionId', response['data'].sessionId);
                localStorage.setItem(
                  'linkedAccounts',
                  JSON.stringify(response['data'].linkedAccounts)
                );
                // added
                localStorage.setItem('selectedMemberId', '');
                localStorage.setItem('actionMemberId', '');
                this.router.navigate(['/login-role-merge']);
              });
            }

          }
        } catch (error: any) {
          this.toaster.error(error);
          this.isloadingSpin = false;
        }
      },
      error: (error) => {
        this.toaster.error(error);
        this.isloadingSpin = false;
      },
    });
  }
  fetchLastRefreshedDate() {
    this.masterSearchService.fetchLastRefreshDate().subscribe({
      next: (response: any) => {
        localStorage.setItem('refresh-date', btoa(encodeURIComponent(JSON.stringify(response.data))))
      }, error: (error: any) => {
        console.log(error)
      }
    })
  }
     callApiService() {
    this.getstatusservice.getStatusData().subscribe({
      next: (response: any) => {
        // localStorage.setItem('recstatus', btoa(JSON.stringify(response.data)));
        // this.statusArray = response.data;
        this.getstatusservice.setStatuses(response.data)
      },
      error: (error: any) => { },
    });
  }
  sendGeoLocation() {
    this.location.getCurrentPosition().subscribe({
      next: (position) => {
        console.log('Latitude:', position.coords.latitude);
        console.log('Longitude:', position.coords.longitude);
        const lat = position.coords.latitude.toString();
        const long = position.coords.longitude.toString();
        localStorage.setItem('lat', lat);
        localStorage.setItem('long', long);
        const reqData: any = {
          lat: lat, long: long
        }
        this._authTransmissionService.fetchUserLoc(reqData).subscribe({
          next: (response) => this.checkNotification(),
          error: (error) => console.log(error)
        })
      },
      error: (error) => {
        console.error('Error getting geolocation:', error);
      },
    });
  }
  async checkNotification() {
    if (Notification.permission === 'default') {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        // console.log(this._fcmTokenService.initializeFCM())
        if (await this._fcmTokenService.initializeFCM()) {
          this.saveFcmToken();
        }
      }
    } else if (Notification.permission === 'granted') {
      if (await this._fcmTokenService.initializeFCM()) {
        this.saveFcmToken();
      }
    }
  }
  saveFcmToken() {
    try {
      const reqBody = {
        device_id: 'BROWSER',
        token_id: localStorage.getItem('fcm_token'),
        platform: 'WEB',
      }
      this.notificationService.saveFcmToken(reqBody).subscribe({
        next: (data: any) => {
          console.log(data, "save fcm token")
        },
        error: (err: any) => console.log(err)
      })
    } catch (error) {
      console.log(error);
    }
    // this.initializeFCM()
  }
  initiateLoginAndProcess() {
    this.LocationGranted()
  }
  LocationGranted() {
    this.isloadingSpin = true
    this.location.isLocationGranted().subscribe((isGranted: boolean) => {
      if (isGranted) {
        this.isloadingSpin = false
        this.authenticate()
      } else {
        this.isloadingSpin = false
        this.dialog.open(ReachAlertPopupComponent, {
          data: { message: ' You cannot login until you turn on location services.' }
        })
      }
    })
  }
  secondAPIcall() {
    this.isloadingSpin = true;
    let loginFormPayload = {
      sessionId: this.sessionId,
      familyCode: this.enteredData,
      phlMemCode: this.memKey,
      memName: this.firstName,
      memSurname: this.lastName,
    };
    this._authTransmissionService.getAuthToken(loginFormPayload).subscribe({
      next: (response: RaintreeResponse) => {
        this.requireFc = response['data'].requiredFamilyCode;
        if (response) {
          this.isloadingSpin = false;
          localStorage.setItem('maskedNumber', response['data'].target);
          localStorage.setItem('session2Id', response['data'].session2Id);
          localStorage.setItem('sessionId', loginFormPayload.sessionId);
          localStorage.setItem('familyCode', loginFormPayload.familyCode);
          localStorage.setItem('phlMemCode', loginFormPayload.phlMemCode);
          localStorage.setItem('memName', loginFormPayload.memName);
          localStorage.setItem('memSurname', loginFormPayload.memSurname);
          this.router.navigate(['/login-authentication-code']);
        }
      },
      error: (error) => {
        this.isloadingSpin = false;
        this.snackbar.snackbar(error, 'ok', 'success-snackbar');
      },
    });
  }
  enteredData: any;
  fcVerifiedIcon: boolean = false;
  onInputChange() {
    const enteredData = this.loginForm.get('fc')?.value;
    if (enteredData?.length == 12) this.fcVerifiedIcon = true;
    this.enteredData = enteredData;
  }
}
